import UploadedFileSave from "@/classes/global/UploadedFileSave";
import API from "@/classes/global/API";

export async function useProcessUploadedFiles(files, modelValue) {

    let safeFiles= [];

    try{
        const fileArray = Array.from(files);

        // Scan all files
        const results = await Promise.all(
            fileArray.map(async (file) => {
                const scanResult = await API.FileVirusScan(file);
                return { file, scanResult };
            })
        );

        // Keep only the files that passed
        safeFiles = results
            .filter(r => r.scanResult === 'Passed')
            .map(r => r.file);

    } catch (error) {

        console.log(error);
    }

    if(safeFiles.length > 0){

        for (const file of safeFiles) {

            // Convert file size from bytes to megabytes
            let fileSize = Math.round((file.size / 1024 / 1024) * 100) / 100;

            if (fileSize < 28) {

                let prepareFile = new UploadedFileSave();

                const convertFile = await getAsBase64(file);
                const splitFile = convertFile.split(';');
                const getContentType = splitFile[0].split(':');
                const getFile = splitFile[1].split(',');

                prepareFile.fileName = file.name;
                prepareFile.contentType = getContentType[1];
                prepareFile.encoding = getFile[0];
                prepareFile.file = getFile[1];

                modelValue.files.push(prepareFile)

            } else {

                // File too big - return back for error message
                return {file: file, value: false};
            }

        }

    }

    async function getAsBase64(file) {

        return await readFile(file)
    }

    function readFile(file) {

        return new Promise((resolve, reject) => {
            // Create file reader
            let reader = new FileReader()

            // Register event listeners
            reader.addEventListener("loadend", e => resolve(e.target.result));
            reader.addEventListener("error", reject);

            reader.readAsDataURL(file);
        })
    }

    return {name: 'file size ok', value: true};

}
